import customAxios from "./axiosConfig";

const AiAssistantService = {
  getCurrentChatBot() {
    const api_url = window.Urls['chat_bot_current_chat_bot']();
    return customAxios.get(api_url);
  },
  getResponse(data) {
    const api_url = window.Urls['chat_bot_send']();
    return customAxios.post(api_url, data);
  },
  getLLMResponse(data) {
    const api_url = window.Urls['llm_bot_send']()
    return customAxios.post(api_url, data)
  },
  getStructuredLLMResponse(data) {
    const api_url = window.Urls['llm_bot_send_structured_message']()
    return customAxios.post(api_url, data)
  },
  resetContext() {
    const api_url = window.Urls['chat_bot_reset_context']();
    return customAxios.post(api_url);
  },
  sendLogoRequest(data) {
    const api_url = window.Urls['logo_bot_send']();
    return customAxios.post(api_url, data);
  },
  getLogoStyleOptions() {
    const api_url = window.Urls['logo_bot_get_style_choices']();
    return customAxios.get(api_url);
  },
  getCurrentLogoBot() {
    const api_url = window.Urls['logo_bot_current_logo_bot']();
    return customAxios.get(api_url);
  },
  getLogos() {
    const api_url = window.Urls['logo-list']()
    return customAxios.get(api_url)
  },
  getLogoImageB64 (id) {
    const api_url = window.Urls['logo_get_logo_img'](id)
    return customAxios.get(api_url)
  },
  deleteLogo(id) {
    const api_url = window.Urls['logo-detail'](id)
    return customAxios.delete(api_url)
  },
  logoRemoveBackground(params) {
    const api_url = window.Urls['logo-remove-background']()
    return customAxios.post(api_url, params)
  },
  uploadNewLogo(data) {
    const getFormData = object => Object.keys(object).reduce((formData, key) => {
      if(Array.isArray(object[key])) {
        formData.append(key, JSON.stringify(object[key]))
      } else {
        formData.append(key, object[key])
      }
      return formData
    }, new FormData())
    const api_url = window.Urls['logo-list']()
    return customAxios.post(api_url, getFormData(data))
  },
  getCurrentFunctionCallingBot() {
    const api_url = window.Urls['function_calling_bot_current_function_calling_bot']()
    return customAxios.get(api_url)
  },
  getFunctionCallingResponse(data) {
    const api_url = window.Urls['function_calling_bot_send']()
    return customAxios.post(api_url, data)
  },
  scanCostImage(company_profile_id, file) {
    const api_url = window.Urls['llm_bot_scan_cost_image']()
    const formData = new FormData()
    formData.append('image', file)
    formData.append('company_profile', company_profile_id)
    return customAxios.post(api_url, formData)
  }
};

export default AiAssistantService;